import { render, staticRenderFns } from "./AamsGiftRegOutStorageReturnDetail.vue?vue&type=template&id=5438f6e2&scoped=true&"
import script from "./AamsGiftRegOutStorageReturnDetail.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegOutStorageReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsGiftRegOutStorageReturnDetail.vue?vue&type=style&index=0&id=5438f6e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438f6e2",
  null
  
)

export default component.exports